<script setup lang="ts">
import type { LayoutEmptyState } from '#layers/listing/types/layout';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const { totalItemsCount, filteredItemsCount, emptyState } = defineProps<{
	totalItemsCount?: number;
	filteredItemsCount?: number;
	emptyState?: LayoutEmptyState;
}>();

const emit = defineEmits<{
	resetFilters: [];
	emptyStateAction: [];
}>();

const { t } = useI18n();

const hasFilters = computed(() => totalItemsCount && (totalItemsCount !== filteredItemsCount));

const emptyProps = computed(() => {
	if (!hasFilters.value && emptyState) {
		return {
			icon: emptyState.icon,
			title: emptyState.title,
			description: emptyState.description,
			actionButtonLabel: emptyState.actionLabel,
			actionButtonIcon: emptyState.actionIcon,
		};
	}

	return {
		description: emptyState?.description || t('layout.empty.description'),
		actionButtonLabel: hasFilters.value ? t('layout.empty.reset_filters') : undefined,
		actionButtonIcon: 'lucide:trash-2',
	};
});

function onActionButtonClicked() {
	if (!hasFilters.value && emptyState) {
		emit('emptyStateAction');
	}
	else {
		emit('resetFilters');
	}
}
</script>

<template>
	<DEmpty
		v-bind="emptyProps"
		data-testid="layout-empty-state"
		@action="onActionButtonClicked"
	/>
</template>
